import Component from '@glimmer/component';
import { underscore } from '@ember/string';

interface AditoolsToolbarTabSignature {
  Element: HTMLButtonElement;
  Args: {
    label: string;
    tab: string;
    activeTab: string;
    iconClass: string;
    disabled?: boolean;
    qaName?: string;
    select: () => void;
  };
}

export default class AditoolsToolbarTab extends Component<AditoolsToolbarTabSignature> {
  get qaName() {
    return this.args.qaName ?? underscore(this.args.tab.toLowerCase());
  }
}
